import BaseComponent from '../base/base-widget/base-widget';
import editForm from './business-info.form';
import { CustomComponentType } from '../../../enums/custom-component-type';
import { forcedLoadSubForm } from '../simple-inputs/extended-field-helper';
import { ConditionalHelper, CustomConditionalType } from '../../../utils/conditional-helper';

export default class BusinessInfoWidget extends BaseComponent {
	static schema(...extend: any) {
		return BaseComponent.schema(
			{
				label: 'Business Info',
				type: CustomComponentType.businessInfo,
				key: CustomComponentType.businessInfo
			},
			...extend
		);
	}

	static editForm = editForm;

	static get builderInfo() {
		return {
			title: 'Business Info',
			group: '',
			weight: 10,
			schema: BusinessInfoWidget.schema()
		};
	}

	constructor(component: any, options: any, data: any) {
		if (!component?.preserveConditional) {
			ConditionalHelper.clearConditionals(component);
			ConditionalHelper.addCustomConditional(component, CustomConditionalType.OnlyShowIfDataContainsId);
		}

		super(component, options, data);
	}

	loadSubForm() {
		if (this.component.formJson) {
			return super.loadSubForm();
		}
		return forcedLoadSubForm(this);
	}
}
